import { useEffect, useState } from "react";
import Corolla2012 from "../images/cars-big/corolla-2012.png";
import Corolla2013 from "../images/cars-big/corolla-2013.png";
import Civic2013 from "../images/cars-big/civic2013.png";
import Tesla from "../images/cars-big/teslamodel3.png";
import Camry from "../images/cars-big/toyota-camry.png";
import Sienna from "../images/cars-big/toyotasienna2014.png";
import emailjs from "@emailjs/browser";

function BookCar() {
  const [modal, setModal] = useState(false); //  class - active-modal

  // booking car
  const [carType, setCarType] = useState("");
  const [pickUp, setPickUp] = useState("");
  const [dropOff, setDropOff] = useState("");
  const [pickTime, setPickTime] = useState("");
  const [dropTime, setDropTime] = useState("");
  const [carImg, setCarImg] = useState("");

  // modal infos
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const [license, setlicense] = useState("");
  const [licenseType, setLicenseType] = useState("");
  const [zipcode, setZipCode] = useState("");
  const [isChecked, setIsChecked] = useState(false);


  // form validity state
  const [isFormValid, setIsFormValid] = useState(false);

  // Form validation function
  const validateForm = () => {
    // Check if all fields are filled and if checkbox is checked
    const allFieldsFilled =
      name &&
      lastName &&
      phone &&
      age &&
      email &&
      license &&
      licenseType &&
      zipcode &&
      carType &&
      pickUp &&
      dropOff &&
      pickTime &&
      dropTime;
    
    setIsFormValid(allFieldsFilled && isChecked);
  };

  // Update validation when any input changes
  useEffect(() => {
    validateForm();
  }, [name, lastName, phone, age, email, license, licenseType, zipcode, carType, pickUp, dropOff, pickTime, dropTime, isChecked]);

  // taking value of modal inputs
  const handleName = (e) => {
    setName(e.target.value);
  };

  const handleLastName = (e) => {
    setLastName(e.target.value);
  };

  const handlePhone = (e) => {
    setPhone(e.target.value);
  };

  const handleAge = (e) => {
    setAge(e.target.value);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleLicense = (e) => {
    setlicense(e.target.value);
  };

  const handleLicenseType = (e) => {
    setLicenseType(e.target.value);
  };

  const handleZip = (e) => {
    setZipCode(e.target.value);
  };

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);  
  };

  // open modal when all inputs are fulfilled
  const openModal = (e) => {
    e.preventDefault();
    const errorMsg = document.querySelector(".error-message");
    if (
      pickUp === "" ||
      dropOff === "" ||
      pickTime === "" ||
      dropTime === "" ||
      carType === ""
    ) {
      errorMsg.style.display = "flex";
    } else {
      setModal(!modal);
      const modalDiv = document.querySelector(".booking-modal");
      modalDiv.scroll(0, 0);
      errorMsg.style.display = "none";
    }
  };

  // disable page scroll when modal is displayed
  useEffect(() => {
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modal]);

  // confirm modal booking
  const confirmBooking = (e) => {
    e.preventDefault();

    const form = e.target.closest("form");
    if (!form.checkValidity()) {
      alert("Please fill out all required fields.");
      return;
    }

 
    emailjs.sendForm(process.env.REACT_APP_TGA_SERVICE_ID, process.env.REACT_APP_TGA_TEMPLATE_ID, form, process.env.REACT_APP_TGA_PUBLIC_KEY).then(
      (result) => {
      
        setModal(!modal);
        const doneMsg = document.querySelector(".booking-done");
        doneMsg.style.display = "flex";
      },
      (error) => {
        console.error("Error sending email:", error.text);
        alert("Something went wrong while sending the email.");
      }
    );

  };


  // taking value of booking inputs
  const handleCar = (e) => {
    setCarType(e.target.value);
    setCarImg(e.target.value);
  };

  const handlePick = (e) => {
    setPickUp(e.target.value);
  };

  const handleDrop = (e) => {
    setDropOff(e.target.value);
  };

  const handlePickTime = (e) => {
    setPickTime(e.target.value);
  };

  const handleDropTime = (e) => {
    setDropTime(e.target.value);
  };

  // based on value name show car img
  let imgUrl;
  switch (carImg) {
    case "Toyota Corolla":
      imgUrl = Corolla2013;
      break;
    case "Honda Civic":
      imgUrl = Civic2013;
      break;
    case "Toyota Camry":
      imgUrl = Camry;
      break;

    case "Tesla":
      imgUrl = Tesla;
      break;
      
    case "Toyota Corolla#2":
      imgUrl = Corolla2012;
      break;
    case "Toyota Sienna":
      imgUrl = Sienna;
      break;
    default:
      imgUrl = "Corolla2013";
  }

  // hide message
  const hideMessage = () => {
    const doneMsg = document.querySelector(".booking-done");
    doneMsg.style.display = "none";
  };


  return (
    <>
      <section id="booking-section" className="book-section">
        {/* overlay */}
        <div
          onClick={openModal}
          className={`modal-overlay ${modal ? "active-modal" : ""}`}
        ></div>

        <div className="container">
          <div className="book-content">
            <div className="book-content__box">
              <h2>Booking Enquiry</h2>

              <p className="error-message">
                All fields required! <i className="fa-solid fa-xmark"></i>
              </p>

              <p className="booking-done">
                Email sent. You will receive a call shortly.{" "}
                <i onClick={hideMessage} className="fa-solid fa-xmark"></i>
              </p>

              <form className="box-form">
                <div className="box-form__car-type">
                  <label>
                    <i className="fa-solid fa-car"></i> &nbsp; Select Your Car
                    Type <b>*</b>
                  </label>
                  <select value={carType} onChange={handleCar} name="car_type">
                    <option>Select your car type</option>
                    <option value="Toyota Corolla">Toyota Corolla#1</option>
                    <option value="Honda Civic">Honda Civic</option>
                    <option value="Toyota Camry">Toyota Camry</option>
                    <option value="Toyota Corolla#2">
                      Toyota Corolla#2
                    </option>
                    <option value="Tesla">Tesla Model3</option>
                    <option value="Toyota Sienna">Toyota Sienna</option>
                  </select>
                </div>

                <div className="box-form__car-type">
                  <label>
                    <i className="fa-solid fa-location-dot"></i> &nbsp; Pick-up{" "}
                    <b>*</b>
                  </label>
                  <select value={pickUp} onChange={handlePick} name="pickup_location">
                    <option>Select pick up location</option>
                    <option>Brampton</option>
                    <option>Whitby</option>
                    <option>Vaughan</option>
                    <option>Oshawa</option>
                    <option>Mississauga</option>
                  </select>
                </div>

                <div className="box-form__car-type">
                  <label>
                    <i className="fa-solid fa-location-dot"></i> &nbsp; Drop-off{" "}
                    <b>*</b>
                  </label>
                  <select value={dropOff} onChange={handleDrop} name="dropoff_location">
                    <option>Select drop off location</option>
                    <option>Brampton</option>
                    <option>Whitby</option>
                    <option>Vaughan</option>
                    <option>Oshawa</option>
                    <option>Mississauga</option>
                  </select>
                </div>

                <div className="box-form__car-time">
                  <label htmlFor="picktime">
                    <i className="fa-regular fa-calendar-days "></i> &nbsp;
                    Pick-up <b>*</b>
                  </label>
                  <input
                    id="picktime"
                    value={pickTime}
                    onChange={handlePickTime}
                    type="date"
                    name="pick_date"
                  ></input>
                </div>

                <div className="box-form__car-time">
                  <label htmlFor="droptime">
                    <i className="fa-regular fa-calendar-days "></i> &nbsp;
                    Drop-off <b>*</b>
                  </label>
                  <input
                    id="droptime"
                    value={dropTime}
                    onChange={handleDropTime}
                    type="date"
                    name="drop_date"
                  ></input>
                </div>

                <button onClick={openModal} type="submit">
                  Search
                </button>
              </form>
              <p className="note"> Customers with G license will get additional discount and preference.
                Free car delivery available if the booking is more than two weeks, delivery and pickup available for a small fee for short term bookings.</p>
            </div>

          </div>
        </div>
      </section>

      {/* modal ------------------------------------ */}

      <div className={`booking-modal ${modal ? "active-modal" : ""}`}>
        {/* title */}
        <div className="booking-modal__title">
          <h2>Complete Reservation</h2>
          <i onClick={openModal} className="fa-solid fa-xmark"></i>
        </div>
        {/* message */}
        <div className="booking-modal__message">
          <h4>
            <i className="fa-solid fa-circle-info"></i> Thanks for your reservation enquiry.
          </h4>
          <p>
            We will be reaching you back via phone or email as soon as possible.
          </p>
        </div>
        {/* car info */}
        <div className="booking-modal__car-info" name="booking-modal-car-info">
          <div className="dates-div">
            <div className="booking-modal__car-info__dates">
              <h5>Location & Date</h5>
              <span>
                <i className="fa-solid fa-location-dot"></i>
                <div>
                  <h6>Pick-Up Date & Time</h6>
                  <p>
                    {pickTime} /{" "}
                    <input type="time" className="input-time"></input>
                  </p>
                </div>
              </span>
            </div>

            <div className="booking-modal__car-info__dates">
              <span>
                <i className="fa-solid fa-location-dot"></i>
                <div>
                  <h6>Drop-Off Date & Time</h6>
                  <p>
                    {dropTime} /{" "}
                    <input type="time" className="input-time"></input>
                  </p>
                </div>
              </span>
            </div>

            <div className="booking-modal__car-info__dates">
              <span>
                <i className="fa-solid fa-calendar-days"></i>
                <div>
                  <h6>Pick-Up Location</h6>
                  <p>{pickUp}</p>
                </div>
              </span>
            </div>

            <div className="booking-modal__car-info__dates">
              <span>
                <i className="fa-solid fa-calendar-days"></i>
                <div>
                  <h6>Drop-Off Location</h6>
                  <p>{dropOff}</p>
                </div>
              </span>
            </div>
          </div>
          <div className="booking-modal__car-info__model">
            <h5>
              <span>Car -</span> {carType}
            </h5>
            {imgUrl && <img src={imgUrl} alt="car_img" />}
          </div>
        </div>
        {/* personal info */}
        <div className="booking-modal__person-info" name="booking-modal-person-info"> 
          <h4>Personal Information</h4>
          <form className="info-form" onSubmit={confirmBooking}>
            <div className="info-form__2col">
              <span>
                <label>
                  First Name <b>*</b>
                </label>
                <input
                  value={name}
                  onChange={handleName}
                  type="text"
                  name="name"
                  placeholder="Enter your first name"
                ></input>
                <p className="error-modal">This field is required.</p>
              </span>

              <span>
                <label>
                  Last Name <b>*</b>
                </label>
                <input
                  value={lastName}
                  onChange={handleLastName}
                  type="text"
                  name="last_name"
                  placeholder="Enter your last name"
                ></input>
                <p className="error-modal ">This field is required.</p>
              </span>

              <span>
                <label>
                  Phone Number <b>*</b>
                </label>
                <input
                  value={phone}
                  onChange={handlePhone}
                  type="tel"
                  name="phone"
                  placeholder="Enter your phone number"
                ></input>
                <p className="error-modal">This field is required.</p>
              </span>

              <span>
                <label>
                  Age <b>*</b>
                </label>
                <input
                  value={age}
                  onChange={handleAge}
                  type="number"
                  placeholder="18"
                ></input>
                <p className="error-modal ">This field is required.</p>
              </span>
            </div>

            <div className="info-form__1col">
              <span>
                <label>
                  Email <b>*</b>
                </label>
                <input
                  value={email}
                  onChange={handleEmail}
                  type="email"
                  name="email"
                  placeholder="Enter your email address"
                ></input>
                <p className="error-modal">This field is required.</p>
              </span>

              <span>
                <label>
                  Driving license number <b>*</b>
                </label>
                <input
                  value={license}
                  onChange={handleLicense}
                  type="text"
                  name="licensenumber"
                  placeholder="Enter your Driving license number"
                ></input>
                <p className="error-modal ">This field is required.</p>
              </span>
            </div>

            <div className="info-form__2col">
              <span>
                <label>
                  Type of License <b>*</b>
                </label>
                <input
                  value={licenseType}
                  onChange={handleLicenseType}
                  type="text"
                  name="licensetype"
                  placeholder="Enter your License type - G, G2 or International"
                ></input>
                <p className="error-modal">This field is required.</p>
              </span>
            </div>
            <div className="info-form__1col">
              <span>
                <label>
                  Preference/Notes <b>*</b>
                </label>
                <input
                  value={zipcode}
                  onChange={handleZip}
                  type="text"
                  name="notes"
                  placeholder="car preference(Sedan 5 seater, Minivan 8 Seater ), any other comments"
                ></input>
                <p className="error-modal ">This field is required.</p>
              </span>
            </div>

            <span className="info-form__checkbox">
              <input type="checkbox" onChange={handleCheckboxChange}
          checked={isChecked}/>
              <p>I agree to provide my email and phone number for communication purposes, understanding they will not be shared with third parties without my consent</p>
            </span>

            <div className="reserve-button">
              <button onClick={confirmBooking}  disabled={!isChecked} >Reserve Now</button>
              {!isChecked && (
          <p className="warning-message">
            Please agree to the terms by checking the box before proceeding.
          </p>
        )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default BookCar;
